"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastingService = void 0;
const Service_1 = require("../Service");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
/**
 * A service for broadcasting video streams. It allows you to start and stop broadcasting.
 * @ignore
 * @noInheritDoc
 */
class BroadcastingService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     */
    constructor(sdk) {
        super(sdk);
    }
    /**
     * Starts broadcasting a stream
     */
    start({ uri = '', hls = false }) {
        if (hls) {
            return VoxeetApi_1.default.hls.start({ conferenceId: this._conferenceId });
        }
        else {
            return VoxeetApi_1.default.externallive.start({ conferenceId: this._conferenceId, data: { uri: uri } });
        }
    }
    /**
     * Stops broadcasting
     */
    stop({ hls = false } = {}) {
        if (hls) {
            return VoxeetApi_1.default.hls.stop({ conferenceId: this._conferenceId });
        }
        else {
            return VoxeetApi_1.default.externallive.stop({ conferenceId: this._conferenceId });
        }
    }
}
__decorate([
    Service_1.ConferenceNotNull()
], BroadcastingService.prototype, "start", null);
__decorate([
    Service_1.ConferenceNotNull()
], BroadcastingService.prototype, "stop", null);
exports.BroadcastingService = BroadcastingService;
